import options from './folder-details.component';

export default {
    selector: 'dtFolderDetailsView',
    options
};



// WEBPACK FOOTER //
// ./app/components/folders-and-labels/folders/folder-details/index.js